import { EntityActionNames, IEntityAction } from '~src/spacesPlatform/components/ActionsMenu/EntityActions/IEntityAction';
import { isSingleSelectServerUserGuest } from '~src/spacesPlatform/components/ActionsMenu/EntityActions/IEntityActionHelpers';

import { AppState } from '../../../app/state/AppState';
import { Messages } from '../../../codegen/Localize';
import { serverUserEditSiteMembership } from '../actions/ServerUserMenuActions';
import { IServerUserInfo } from '../models/IServerUserInfo';

export const ServerUserEditSiteMembershipUsersAction: IEntityAction<IServerUserInfo, {}> = {
  name: EntityActionNames.ServerUserEditSiteMembership,
  translateName: Messages.siteMembership_action,
  isVisible: (_targetItems: IServerUserInfo[], _state: AppState) => {
    return true;
  },
  isClickable: (_availableActions: {}, targetItems: IServerUserInfo[], _state: AppState) => {
    return targetItems.length > 0 && !isSingleSelectServerUserGuest(targetItems);
  },
  createReduxAction: (targetItems: IServerUserInfo[]) => serverUserEditSiteMembership(targetItems)
};
